var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h5", { staticClass: "heading" }, [
      _vm._v(_vm._s(_vm.finishGroup.name))
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "finishes" },
      _vm._l(_vm.finishGroup.finishes, function(finish, index) {
        return _c("Finish", {
          key: index,
          attrs: { finish: finish, finishSelectedProp: _vm.finishSelectedProp },
          on: { finishSelected: _vm.onFinishSelected }
        })
      }),
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }